// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3RigX","head":"Table_head__2YnTt","col":"Table_col__1tMk0"};